<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div
  class="form-group toggle-group mb-0"
  [ngClass]="{ 'no-margin': hideMargins }">
  @if (label) {
    <label [xdaTranslate]="label"></label>
  }
  @for (item of list; track item) {
    <section>
      <xrx-toggle-switch
        [label]="item[labelKey]"
        [switchOn]="item[valueKey]"
        [isMfd]="isMfd"
        (toggle)="onToggle($event, item)"></xrx-toggle-switch>
    </section>
  }
</div>
